// export const BASE_URL = "https://marketingemailtool.com/order-woo/api/";
const isENVDev = false;
export const BASE_URL = isENVDev ? "https://orders.vinhyenit.com/tts-api/api/" : "https://orders.vinhyenit.com/tts-api/api/";
